export default "__VITE_ASSET__Ds1OQ7OM__"